import { FC, useEffect } from 'react';
import {
  Container,
  Box,
  Checkbox,
  Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { observer } from "mobx-react"
import store from "./store"
import { useTranslation } from 'react-i18next';
import { GridColDef, GridActionsCellItem } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import OutgoingDocumentPopupForm from './../OutgoingDocumentAddEditView/popupForm'
import CustomButton from 'components/Button';
import dayjs from 'dayjs';
import FileViewer from "components/FileViewer";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from '@mui/icons-material/Assignment';
import ChecklistIcon from '@mui/icons-material/Checklist';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import MainStore from 'MainStore';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Typography from '@mui/material/Typography';

type OutgoingDocumentListViewProps = {
  idMain: number;
  disableEdit: boolean;
};

const OutgoingDocumentListView: FC<OutgoingDocumentListViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  useEffect(() => {
    if (store.idMain !== props.idMain) {
      store.idMain = props.idMain
    }
    store.loadOutgoingDocuments()
    return () => store.clearStore()
  }, [props.idMain])

  const columns: GridColDef[] = [
    {
      field: 'upload_id',
      flex: 1,
      headerName: translate("ЭЦП"),
      renderCell: (param) => {
        return <div>
          <Tooltip title={translate("Подписать")}>
            <IconButton size='small' onClick={() => {
              if (!MainStore.currentUser.has_signing_rights) {
                MainStore.openErrorDialog(translate("У вас нет доступа на подписание документов, обратитесь к администратору"))
                return;
              }

              store.signApplicationPayment(param.row.id, 0, () => {

              })
            }}>
              <AssignmentIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={translate("Подписавшие")}>
            <IconButton size='small' onClick={() => {
              store.ecpListOpen = true;
              store.loadGetSignByFileId(param.row.id)
            }}>
              <ChecklistIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Назначить подписантов">
            <IconButton size='small' onClick={() => store.openSignerDialog(param.row.id)}>
              <GroupAddIcon />
            </IconButton>
          </Tooltip>
        </div>
      },
    },
    {
      field: 'name',
      headerName: translate("label:outgoingDocumentListView.name"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_outgoing_document_column_name"> {param.row.name} </div>),
      renderHeader: (param) => (<div data-testid="table_outgoing_document_header_name">{param.colDef.headerName}</div>)
    },
    // {
    //   field: 'document_type_name',
    //   headerName: translate("label:outgoingDocumentListView.document_type_id"),
    //   flex: 1,
    //   renderCell: (param) => (<div data-testid="table_outgoing_document_column_document_type_id"> {param.row.document_type_name} </div>),
    //   renderHeader: (param) => (<div data-testid="table_outgoing_document_header_document_type_id">{param.colDef.headerName}</div>)
    // },
    {
      field: 'document_number',
      headerName: translate("label:outgoingDocumentListView.document_number"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_outgoing_document_column_document_number"> {param.row.document_number} </div>),
      renderHeader: (param) => (<div data-testid="table_outgoing_document_header_document_number">{param.colDef.headerName}</div>)
    },
    {
      field: 'document_date',
      headerName: translate("label:outgoingDocumentListView.document_date"),
      flex: 1,
      renderCell: (param) => (
        <div data-testid="table_outgoing_document_column_document_date">
          {param.row.document_date ? dayjs(param.row.document_date).format('DD.MM.YYYY') : ''}
        </div>
      ),
      renderHeader: (param) => (<div data-testid="table_outgoing_document_header_document_date">{param.colDef.headerName}</div>)
    },
    // version и is_final скрыты
  ];

  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      <PopupGrid
        title={translate("label:outgoingDocumentListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteOutgoingDocument(id)}
        onEditClicked={(id: number) => store.onEditClicked(id)}
        columns={columns}
        hideAddButton
        customActionButton={(id: number) => {
          const row = store.data.find((item: any) => item.id === id);
          return (
            <><GridActionsCellItem
              icon={<Tooltip title={translate("download")}><DownloadIcon /></Tooltip>}
              label="Download"
              data-testid={`download_button_${id}`}
              onClick={() => store.downloadFile(id, row?.name || '')}
              color="inherit"
            />
              <GridActionsCellItem
                icon={<Tooltip title={translate("view")}><RemoveRedEyeIcon /></Tooltip>}
                label="View"
                data-testid={`download_button_${id}`}
                onClick={() => store.OpenFileFile(id, row?.file_name || '')}
                color="inherit"
              />
            </>
          );
        }}
        hideDeleteButton={props.disableEdit}
        hideEditButton={props.disableEdit}
        customBottom={
          !props.disableEdit ? (<Box>
            <CustomButton
              variant='contained'
              sx={{ mb: 1 }}
              id={`outgoingDocumentAddButton`}
              onClick={() => store.onEditClicked(0)}
              endIcon={<AddIcon />}
            >
              {translate('add')}
            </CustomButton>
          </Box>) : (<></>)
        }
        data={store.data}
        tableName="outgoing_document"
      />

      <OutgoingDocumentPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel()
          store.loadOutgoingDocuments()
        }}
      />

      <FileViewer
        isOpen={store.isOpenFileView}
        onClose={() => { store.isOpenFileView = false }}
        fileUrl={store.fileUrl}
        fileType={store.fileType} />

      {/* Диалог назначения подписантов */}
      <Dialog
        open={store.signerDialogOpen}
        onClose={() => store.closeSignerDialog()}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Подписанты документа
          <IconButton
            aria-label="close"
            onClick={() => store.closeSignerDialog()}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Autocomplete
            options={store.signerSearchOptions as any[]}
            getOptionLabel={(o: any) =>
              `${o.full_name}${o.position ? ' — ' + o.position : ''}${o.department_name ? ' (' + o.department_name + ')' : ''}`
            }
            getOptionKey={(o: any) => o.id}
            isOptionEqualToValue={(o: any, v: any) => o.id === v.id}
            filterOptions={(x) => x}
            loading={store.signerSearchLoading}
            onChange={(_e, val: any) => {
              if (val) {
                store.addSigner(val.id);
              }
            }}
            onInputChange={(_e, val) => {
              if (val.length >= 2) store.searchSignerUsers(val);
              else store.signerSearchOptions = [];
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                label="Поиск сотрудника (has_signing_rights)"
                placeholder="Начните вводить ФИО или должность..."
              />
            )}
            sx={{ mb: 2 }}
            noOptionsText="Нет результатов"
          />

          {(store.signerDialogSigners as any[]).length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Подписанты не назначены
            </Typography>
          ) : (
            <List dense>
              {(store.signerDialogSigners as any[]).map((s: any) => (
                <ListItem key={s.id} divider>
                  <ListItemText
                    primary={s.user_full_name}
                    secondary={[s.user_position, s.department_name].filter(Boolean).join(' · ')}
                  />
                  <ListItemSecondaryAction>
                    {s.has_signed ? (
                      <Tooltip title="Уже подписал">
                        <HowToRegIcon color="success" />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Удалить">
                        <IconButton
                          size="small"
                          onClick={() => store.removeSigner(s.id)}
                        >
                          <PersonRemoveIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={store.ecpListOpen}
        onClose={() => { store.ecpListOpen = false; }}
        maxWidth="md"
        fullWidth
      >
        <DialogActions>
          <IconButton
            aria-label="close"
            onClick={() => { store.ecpListOpen = false; }}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent sx={{ justifyItems: 'center' }}>
          <h3>Список подписавших документ</h3>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      ФИО
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      Отдел
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                      Дата подписания
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {store.signData.map((row, index) => (
                    <tr
                      key={row.id}
                      className={`hover:bg-blue-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                        }`}
                    >
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm font-medium text-gray-900">
                          {row.employee_fullname || 'Не указано'}
                        </span>
                      </td>
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm text-gray-700">
                          {row.structure_fullname || 'Не указано'}
                        </span>
                      </td>
                      <td className="px-4 py-4 border-b border-gray-200">
                        <span className="text-sm font-mono text-gray-800">
                          {formatDateTime(row.timestamp)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


          </div>

        </DialogContent>
      </Dialog>
    </Container>
  );
})

export default OutgoingDocumentListView